module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startbutton"
  }, [_c('button', {
    staticClass: "start",
    attrs: {
      "disabled": _vm.isStarted
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startGame()
      }
    }
  }, [_vm._v("\n    START！\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ba81a44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartButton.vue
// module id = 25
// module chunks = 0